/**
 * Themes available in the application
 */
export enum Theme {
    Shopliftr = "SHOPLIFTR",
    Rrd = "RRD"
}
